var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
define(["require", "exports", "jquery", "@ext_domfilter/Resources/Private/TypeScript/Hilitor", "@ext_textexpander/Resources/Private/TypeScript/ExpandTextInstance", "@ext_domfilter/Resources/Private/TypeScript/SearchParams"], function (require, exports, $, Hilitor_1, ExpandTextInstance_1, SearchParams_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var mainContainerSelector = '.content-main';
    var highlightSearchWords = (function (searchStringsSanitized) {
        var filterRegexes = SearchParams_1.buildFilterRegexes(searchStringsSanitized);
        var parentTabElements = [];
        var parentFoldableElements = [];
        var matchingElements = detectMatchingElements($(mainContainerSelector), filterRegexes);
        if (matchingElements.length === 0) {
            return;
        }
        // If any tab result info exists, remove it
        $('.search-highlight-tab-info').remove();
        var hilitors = [];
        matchingElements.forEach(function (element, index) {
            // Skip persis cards
            var currentElement = $(element);
            if (currentElement.closest('.frame-type-tx_ufpersis_sel_subpg').length > 0) {
                return true;
            }
            var expandableContainer = currentElement.closest('.expandable-text-container');
            if (expandableContainer.length > 0) {
                ExpandTextInstance_1.default.expandContainer(expandableContainer);
                // We can skip further processing because the textexpander contents are located inside
                // the div.p element which is processed on its own.
                return true;
            }
            // Push matching element to parentTabElements array if any parent element is tab
            var tabElement = currentElement.closest('.tab-pane');
            if (tabElement.length > 0) {
                parentTabElements.push(tabElement);
            }
            // Push matching element to parentFoldableElements array if any parent element is foldable
            var foldableElement = currentElement.closest('.card-foldable');
            if (foldableElement.length > 0) {
                parentFoldableElements.push(foldableElement);
            }
            // Highlight text
            if (!hilitors[index]) {
                hilitors[index] = new Hilitor_1.default(element);
                hilitors[index].setMatchType('open');
            }
            hilitors[index].apply(searchStringsSanitized.join(' '));
            return true;
        });
        if (parentTabElements.length > 0) {
            parentTabElements.forEach(function (tabPane) {
                if (tabPane.data('search-highlight-processed')) {
                    return;
                }
                tabPane.data('search-highlight-processed', 1);
                var numberOfResults = tabPane.find('mark').length;
                var infoBadge = '<span class="search-highlight-tab-info">' + numberOfResults + '</span>';
                var tabHeaderElement = getTabHeaderElement(tabPane);
                tabHeaderElement.append(infoBadge);
            });
            // Set first tab with results active
            $(mainContainerSelector).find('.tabber').each(function (index, element) {
                var tabber = $(element);
                var firstTab = tabber.find('.tab-pane mark').first().closest('.tab-pane');
                var firstTabHeader = getTabHeaderElement(firstTab);
                firstTabHeader.tab('show');
            });
        }
        // Unfold foldables
        if (parentFoldableElements.length > 0) {
            parentFoldableElements.forEach(function (element) {
                if (element.data('search-highlight-processed')) {
                    return;
                }
                element.data('search-highlight-processed', 1);
                var foldable = element.find('.collapse');
                foldable.collapse('show');
            });
        }
    });
    function getTabHeaderElement(element) {
        var tabId = '#' + element.attr('aria-labelledby');
        return $(tabId);
    }
    function detectMatchingElements(element, filterRegexes) {
        var e_1, _a;
        var matches = [];
        var childElements = element.find('h1,h2,h3,h4,h5,h6,p,div.p,li,th,td,div.caption');
        var _loop_1 = function (filterRegex) {
            childElements.each(function (index, htmlElement) {
                if ($(htmlElement).text().match(filterRegex)) {
                    matches.push(htmlElement);
                }
            });
        };
        try {
            for (var filterRegexes_1 = __values(filterRegexes), filterRegexes_1_1 = filterRegexes_1.next(); !filterRegexes_1_1.done; filterRegexes_1_1 = filterRegexes_1.next()) {
                var filterRegex = filterRegexes_1_1.value;
                _loop_1(filterRegex);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (filterRegexes_1_1 && !filterRegexes_1_1.done && (_a = filterRegexes_1.return)) _a.call(filterRegexes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return matches;
    }
    var Search = /** @class */ (function () {
        function Search(searchWords) {
            this.searchWords = searchWords;
        }
        Search.prototype.initialize = function () {
            var searchStringsSanitized = SearchParams_1.parseSearchStrings(this.searchWords.join(' '));
            highlightSearchWords(searchStringsSanitized);
        };
        return Search;
    }());
    exports.default = Search;
});
